﻿import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router'
import { connect } from 'react-redux';
import {AgGridReact} from 'ag-grid-react';
import service from '../../services/role-services';

class RolesList extends Component {
    constructor(props, context) {
        super(props, context);

        this.addNewRole = this.addNewRole.bind(this);
        this.handleResize = this.handleResize.bind(this);

        var tableHeight = this.getTableHeight();
        this.state = {
            tableHeight
        };

        this.gridOptions = null;
    }

    componentDidMount() {
        var self = this;

        this.props.onGetRoles();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        var self = this;
        this.props.onUnload();
        window.removeEventListener('resize', this.handleResize);
    }

    getTableHeight(){
        return window.innerHeight - 64/*header*/ - 20;
    }

    handleResize(e) {
        setTimeout(() => {
            var tableHeight = this.getTableHeight();
            this.setState({tableHeight: tableHeight});
        }, 200);
    }

    addNewRole() {
        browserHistory.push('/role/0');
    }

    onGridReady(options) {
        console.log(options);
        this.gridOptions = options;
        this.setGridData();
    }

    setGridData() {
        if(this.gridOptions && this.props && this.props.roles){
            this.gridOptions.api.setRowData(this.props.roles);
        }
    }

    queuesColumns() {
        var self = this;
        var defWidth = 80;
        var columnDefs = [
            {
                headerName: "Id",
                field: "Id",
                headerTooltip: "Id",
                width: 60,
                pinned: true,
            },
            {
                headerName: 'Role Name',
                width: 160,
                headerTooltip: "Role Name",
                pinned: true,
                field: "RoleName",
                cellStyle: {paddingTop: 0, textAlign: "left"},
                //cellRenderer: reactCellRendererFactory(DomainCellRenderer)
            },
            {headerName: "Counties Allowed", headerTooltip: "Counties Allowed", field: "CountiesAllowed"},
            {headerName: "Fire Hazmat", headerTooltip: "Fire Hazmat", field: "FireHazmat"},
            {headerName: "Police Crime", headerTooltip: "Police Crime", field: "PoliceCrime"},
            {headerName: "Rescue Trauma", headerTooltip: "Rescue Trauma", field: "RescueTrauma"},
            {headerName: "Traffic", headerTooltip: "Traffic", field: "Traffic"},
            {headerName: "Smoke Water", headerTooltip: "Smoke Water", field: "SmokeWater"},
            {headerName: "Weather", headerTooltip: "Weather", field: "Weather"},
            {headerName: "Third Alarm", headerTooltip: "Third Alarm", field: "ThirdAlarm"},
            {headerName: "National", headerTooltip: "National", field: "National"},
            {headerName: "International", headerTooltip: "International", field: "International"},
            {headerName: "Local", headerTooltip: "Local", field: "Local"},

            {headerName: "Send Incident", headerTooltip: "Send Incident", field: "SendIncident"},
            {headerName: "Send Confirm", headerTooltip: "Send Confirm", field: "SendConfirm"},
            {headerName: "Approve Media", headerTooltip: "Approve Media", field: "ApproveMedia"},
            {headerName: "Approve Incident", headerTooltip: "Approve Incident", field: "ApproveIncident"},
            {headerName: "Get Media Level", headerTooltip: "Get Media Level", field: "GetMediaLevel"},
            {headerName: "Claim Incident", headerTooltip: "Claim Incident", field: "ClaimIncident"},
            {headerName: "Confiscate Claim", headerTooltip: "Confiscate Claim", field: "ConfiscateClaim"},
            {headerName: "Release Claim", headerTooltip: "Release Claim", field: "ReleaseClaim"},
            {headerName: "Send PreAlert", headerTooltip: "Send PreAlert", field: "SendPreAlert"},
            {headerName: "Incidents", headerTooltip: "Incidents", field: "Incidents"},
            {headerName: "Function Vote", headerTooltip: "Function Vote", field: "FunctionVote"},
            {headerName: "Allow Stealth", headerTooltip: "Allow Stealth", field: "AllowStealth"},
            {headerName: "Can Delete Media", headerTooltip: "Can Delete Media", field: "CanDeleteMedia"},
            {headerName: "See claims", headerTooltip: "See claims", field: "SeeClaims"},
            {headerName: "Send Blog", headerTooltip: "Send Blog", field: "SendBlog"},
            {headerName: "Function Edit Profile", headerTooltip: "Function Edit Profile", field: "FunctionEditProfile"},
            {headerName: "Function Search by Member Id", headerTooltip: "Function Searchby Member Id", field: "FunctionSearchbyMemberId"},

            {headerName: "Bnn Chat", headerTooltip: "Bnn Chat", field: "BnnChat"},
            {headerName: "Bnn Tac Rooms", headerTooltip: "Bnn Tac Rooms", field: "BnnTacRooms"},
            {headerName: "Chat Moderator", headerTooltip: "Chat Moderator", field: "ChatModerator"},
            {headerName: "Consolidated Chat", headerTooltip: "Consolidated Chat", field: "ConsolidatedChat"},

            {headerName: "Window Blog", headerTooltip: "Window Blog", field: "WindowBlog"},
            {headerName: "Window SendJob", headerTooltip: "Window SendJob", field: "WindowSendJob"},
            {headerName: "Window Admin", headerTooltip: "Window Admin", field: "WindowAdmin"},
            {headerName: "Window Member Stats", headerTooltip: "Window Member Stats", field: "WindowMemberStats"},
            {headerName: "Window Resources", headerTooltip: "Window Resources", field: "WindowResources"},
            {headerName: "Window Messaging", headerTooltip: "Window Messaging", field: "WindowMessaging"},
            {headerName: "Window Rist", headerTooltip: "Window Rist", field: "WindowRist"},
            {headerName: "Window Send Job Free Form", headerTooltip: "Window Send Job Free Form", field: "WindowSendJobFreeForm"},
            {headerName: "Window Send Job Intl", headerTooltip: "Window Send Job Intl", field: "WindowSendJobIntl"},
            {headerName: "Tab Email", headerTooltip: "Tab Email", field: "TabEmail"},
            {headerName: "Window VM Media Tips", headerTooltip: "Window VM Media Tips", field: "WindowVmMediaTips"},
            {headerName: "Window Search", headerTooltip: "Window Search", field: "WindowSearch"},
            {headerName: "Window History", headerTooltip: "Window History", field: "WindowHistory"},
            {headerName: "Window Profile", headerTooltip: "Window Profile", field: "WindowProfile"},

            {headerName: "Function Text Message", headerTooltip: "Function Text Message", field: "FunctionTextMessage"},
            {headerName: "Function Pvt Chat", headerTooltip: "Function Pvt Chat", field: "FunctionPvtChat"},
            {headerName: "Broadcast", headerTooltip: "Broadcast", field: "Broadcast"},

            {headerName: "Hover User Info", headerTooltip: "Hover User Info", field: "HoverUserInfo"},
            {headerName: "Include In Oul", headerTooltip: "Include In Oul", field: "IncludeInOul"},
            {headerName: "Include In Messaging", headerTooltip: "Include In Messaging", field: "IncludeInMessaging"},
            {headerName: "Map Members", headerTooltip: "Map Members", field: "MapMembers"},
            {headerName: "Alert Member", headerTooltip: "Alert Member", field: "AlertMember"},

            {headerName: "Allow Webview", headerTooltip: "Allow Webview", field: "AllowWebview"},
            {headerName: "Allow Chat", headerTooltip: "Allow Chat", field: "AllowChat"},
            {headerName: "Allow VScan", headerTooltip: "Allow VScan", field: "AllowVScan"},
            {headerName: "Allow VText", headerTooltip: "Allow VText", field: "AllowVText"},
            {headerName: "Allow OpenMhz", headerTooltip: "Allow OpenMhz", field: "AllowOpenMhz"},
        ];
        return columnDefs;
    }

    onRowSelected() {
        var selectedRow = this.gridOptions.api.getSelectedRows()[0];

        if(selectedRow){
            browserHistory.push(`/role/${selectedRow.Id}`);
        }
    }

    render() {
        console.log('render roles list');
        const { roles } = this.props;
        this.setGridData();
        return (
            <div ref="mainComponent" className="ag-material" style={{width: "100%", margin: "auto", height: this.state.tableHeight + "px"}}>
                <AgGridReact
                    colWidth={120}
                    minColWidth={50}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.queuesColumns()}
                    onSelectionChanged={this.onRowSelected.bind(this)}
                    rowSelection="single"
                    enableSorting="true"
                    enableFilter="true"
                    enableColResize="true"
                />
            </div>
        );
    }
}

RolesList.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.roles});

const mapDispatchToProps = dispatch => ({
    onGetRoles: () =>
        dispatch({type: 'REQUEST_ROLES', payload: service.RoleServices.getRoles()}),
    onUnload: () =>
        dispatch({type: 'ROLES_PAGE_UNLOADED'})
});

export default connect(mapStateToProps, mapDispatchToProps)(RolesList);